import { getColorScheme } from "@appally/lib/utils/colorSchemes";
import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys);

// const box = definePartsStyle({
//   control: defineStyle({
//     rounded: 2,
//     margin: 0,
//     order: 2,
//   }),
//   container: defineStyle({
//     border: "2px solid",
//     borderColor: "gray.300",
//     padding: 4,
//     borderRadius: 4,
//     flexFlow: "column",
//     alignItems: "flex-start",
//     _checked: {
//       bg: "purple.100",
//       borderColor: "purple.500",
//     },
//   }),
//   label: defineStyle({
//     color: "gray.700",
//     fontSize: "md",
//     p: 0,
//     m: 0,
//     paddingBottom: 8,
//     order: 0,
//     _dark: {
//       color: "white",
//     },
//   }),
// });

// const boxImage = definePartsStyle({
//   control: defineStyle({
//     rounded: "full",
//   }),
//   container: defineStyle({
//     border: "2px solid",
//     borderColor: "gray.300",
//     padding: 2,
//     borderRadius: 4,
//     alignItems: "flex-start",
//   }),
//   label: defineStyle({
//     color: "gray.700",
//     fontSize: "md",
//     p: 0,
//     m: 0,
//     paddingBottom: 2,
//     order: 0,
//     _dark: {
//       color: "white",
//     },
//   }),
// });

const boxed = definePartsStyle((props) => {
  const { main, light, text, tint } = getColorScheme(props.colorScheme);
  return {
    container: {
      border: "2px solid",
      borderColor: tint,
      padding: 4,
      borderRadius: 16,
      _checked: {
        borderColor: main,
        bg: tint,
        _hover: {
          bg: tint,
        },
      },
      _hover: {
        bg: tint,
      },
    },
    control: {
      borderColor: "gray.300",
      boxSize: 5,
      marginRight: 4,
    },
    label: {
      color: main,
    },
  };
});

const circle = definePartsStyle((props) => {
  const { main, light, text, tint } = getColorScheme(props.colorScheme);
  return {
    container: {
      rounded: "full",
      marginRight: 2,
      _checked: {
        borderColor: main,
        bg: main,
        color: "white",
        _dark: {
          bg: light,
        },
      },
    },
    control: {
      borderColor: main,
      boxSize: 6,
      rounded: "full",
      _dark: {
        borderColor: light,
      },
    },
    label: {
      color: text,
    },
  };
});

export const Checkbox = defineMultiStyleConfig({
  variants: { boxed, circle },
  defaultProps: {
    size: "lg",
    variant: "boxed",
    colorScheme: "primary",
  },
});
